import "invokers-polyfill";
import "scrollyfills";

// Polyfills `Math.clamp`
if (typeof Math.clamp !== "function") {
  Math.clamp = function(x, lower, upper) {
    return Math.min(Math.max(x, lower), upper);
  }
}

// Polyfills `anchor` attribute.
if (!("anchorElement" in document.documentElement.style)) {
  function polyfill(element) {
    let anchorName = element.getAttribute("anchor");
    const anchor = document.getElementById(anchorName);
    element.anchorElement = anchor;

    if (anchor) {
      anchorName = `--${anchorName}`;
      anchor.style.anchorName = anchorName;
      element.style.positionAnchor = anchorName;
    } else {
      element.style.positionAnchor = "";
    }
  }

  const targets = document.querySelectorAll(`[anchor]`);
  const observer = new MutationObserver(([mutation]) => {
    polyfill(mutation.target);
  });
  targets.forEach((element) => {
    polyfill(element);

    observer.observe(element, {
      attributeFilter: ["anchor"],
    });
  });
}

/**
 * Sets actual value of 1vw in pixels without scrollbar.
 *
 * When using `50vw`, it includes the scrollbar width, affecting our
 * calculations. We use ResizeObserver to set the actual value of 1vw
 * in pixels to the property `--vw`.
 *
 * When vw unit is needed, use `var(--vw, 1vw) * X` instead of `Xvw`.
 */
new ResizeObserver(() => {
  requestAnimationFrame(() => {
    const { clientWidth, style } = document.documentElement;
    style.setProperty("--spacing-vw", `${clientWidth / 100}px`);
  });
}).observe(document.body);
